import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceExpenseHistoryService {

    api_url = environment.url;

    constructor(private http: HttpClient) { }

    private toQueryString(params: any = {}): string {
        const cleanParams: any = {};
        Object.keys(params || {}).forEach((key) => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                cleanParams[key] = String(value);
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        return queryString ? `?${queryString}` : '';
    }

    getExpenseHistory(params: any = {}) {
        return this.http.get(`${this.api_url}maintenance/expense-history${this.toQueryString(params)}`);
    }
}
